import { styled } from "@mui/material/styles";

const THUMBNAILS_TO_SHOW = 5;

export const Wrapper = styled("div")({
    position: "relative",
});

export const ImagesWrapper = styled("div")(({ theme }) => ({
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
        gap: theme.spacing(1),
        display: "grid",
        maxHeight: 475,
        flexDirection: "row",
        gridTemplateRows: new Array(THUMBNAILS_TO_SHOW).fill("1fr").join(" "),
        gridTemplateColumns: "auto 100px",
        '&[data-single-image="true"]': {
            gridTemplateColumns: "auto",
        },
    },
    [theme.breakpoints.down("lg")]: {
        display: "flex",
        scrollSnapType: "x mandatory",
        overflowX: "scroll",
        flexWrap: "nowrap",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
}));

export const GalleryImageWrapper = styled("div")(({ theme }) => ({
    border: "none",
    backgroundColor: theme.palette.action.disabledBackground,
    padding: 0,
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    "& .gallery-image-icon-button": {
        display: "none",
    },
    [theme.breakpoints.up("lg")]: {
        "&:nth-of-type(1)": {
            gridRow: `span ${THUMBNAILS_TO_SHOW}`,
            "&:before": {
                display: "none",
            },
            "& .gallery-image-icon-button": {
                display: "block",
            },
            "&:hover .gallery-image-icon-button": {
                opacity: 1,
            },
        },
        [`&:nth-of-type(n+${THUMBNAILS_TO_SHOW + 2})`]: {
            display: "none",
        },
    },
    [theme.breakpoints.down("lg")]: {
        width: "100%",
        minWidth: "100%",
        height: 340,
        scrollSnapAlign: "center",
    },
    [theme.breakpoints.down("sm")]: {
        height: 250,
    },
    ["@media (hover: hover)"]: {
        "&:hover": {
            "&:before": {
                opacity: 0.3,
            },
        },
        "&:before": {
            content: '""',
            position: "absolute",
            opacity: 0,
            height: "100%",
            width: "100%",
            backgroundColor: theme.palette.common.white,
            transition: theme.transitions.create("opacity", {
                duration: theme.transitions.duration.short,
            }),
        },
    },
}));
